import { useQuery } from "@apollo/client";
import { gqlDashboard } from "gql";
import {
  IGetTeamPerformanceInput,
  ITeamPerformance,
} from "gql/Dashboard/queries";
import { useMemo, useState } from "react";
import { Line } from "react-chartjs-2";
import { hexToRGBA } from "utils/colors";
import { percentColor } from "utils/string";

export const options = {
  responsive: true,
  elements: {
    point: {
      radius: 0,
    },
  },
  scales: {
    x: {
      display: false,
      ticks: {
        display: false,
      },
      grid: {
        display: false,
      },
    },
    y: {
      display: false,
      ticks: {
        display: false,
      },
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    tooltip: {
      enabled: false,
    },
    legend: {
      display: false,
    },
  },
};

interface ITeamLineChart {
  team: string;
  last7DaysPercent: number;
  width?: number;
  height?: number;
}
const TeamLineChart = (props: ITeamLineChart) => {
  const { team, last7DaysPercent, width = 150, height = 25 } = props;
  const color = percentColor(last7DaysPercent);
  const [performance, setPerformance] = useState<ITeamPerformance[]>();
  useQuery<
    { teamPerformance: ITeamPerformance[] },
    {
      getTeamPerformanceInput: IGetTeamPerformanceInput;
    }
  >(gqlDashboard.queries.GET_TEAM_PERFORMANCE, {
    skip: !team,
    variables: {
      getTeamPerformanceInput: {
        team,
      },
    },
    onCompleted: ({ teamPerformance }) => {
      setPerformance(teamPerformance);
    },
  });

  return useMemo(
    () =>
      performance ? (
        <Line
          options={options}
          data={{
            labels: performance.map((p) => `${p.month}/${p.year}`),
            datasets: [
              {
                data: performance.map((p) => p.score),
                borderColor: hexToRGBA([color], 1)[0],
                borderWidth: 2,
              },
            ],
          }}
          height={height}
          width={width}
        />
      ) : (
        <></>
      ),
    [performance]
  );
};

export default TeamLineChart;
